import { useEffect } from "react";
import { useRouteContext, useRouter } from "@tanstack/react-router";
import { Browser } from "@capacitor/browser";
import { ServicePackageEnum } from "@repo/lib";
import { parseDeepLink } from "@/lib/deep-link";

export const useUserPilotInitializer = (): void => {
  const { user } = useRouteContext({ strict: false });
  const router = useRouter();
  const {
    codUsuario,
    email,
    apelido,
    nome,
    sobrenome,
    especialidades,
    pacotesServicos,
    possivelDataFimTrialAssistPro,
  } = user;

  useEffect(() => {
    if (codUsuario === 0) {
      return;
    }

    // Isso garante que sempre teremos a especialidade com um separador.
    // E com isso, no userpilot seremos capazes de filtrar contains "|51|" e isso vai garantir
    // que é único. Não fui troll.
    // O resultado aqui é |51||52||53|
    const especialidadeString = especialidades
      ?.map((x) => `|${x.codEspecialidade}|`)
      .join();

    const pacoteServicosString = pacotesServicos
      .map((x) => `|${x.codPacoteServicos}|`)
      .join();

    const pacoteAssist = pacotesServicos.find((x) => x.grupoUpgrade === "Assist");

    const dataFimTrialAssistPro =
      possivelDataFimTrialAssistPro.dataFimTrialAssistPro || "";
      
    const dataSimuladaFimTrialAssistPro = pacotesServicos.some(
      (x) => x.codPacoteServicos === ServicePackageEnum.Pro.valueOf(),
    )
      ? ""
      : dataFimTrialAssistPro;

    window.userpilot?.identify(String(codUsuario), {
      name: apelido ?? `${nome} ${sobrenome}`,
      email,
      especialidades: especialidadeString,
      pacotesServicos: pacoteServicosString,
      pacoteAssistCancelado: pacoteAssist?.cancelado,
      pacoteAssistDataFimTrial: pacoteAssist?.dataFimTrial ?? "",
      pacoteAssistTrialAtivo: pacoteAssist?.trialAtivo,
      pacoteAssistDataContratacao: pacoteAssist?.dataContratacao,
      dataSimuladaFimTrialAssistPro,
    });

    window.userpilot?.on("open_url", async (event) => {
      const isDeeplink = await parseDeepLink(event.URL, router, false);

      if (isDeeplink) {
        return;
      }

      void Browser.open({
        url: event.URL,
        windowName: event.new_window ? "_blank" : "_self",
      });
    });

    return () => {
      window.userpilot?.off("open_url");
    };
  }, [
    codUsuario,
    email,
    apelido,
    nome,
    sobrenome,
    pacotesServicos,
    router,
    especialidades,
    possivelDataFimTrialAssistPro,
  ]);
};
